module.exports = __webpack_public_path__ + "static/cvent-b7cfa365ee4ade11bc516d5044e4ab7f.png";